import React from "react";

const PrivacyPolicy = () => {
  return (
   <div className=" bg-gray-900">
     <div className="max-w-3xl mx-auto p-8 bg-gray-900 text-white rounded-lg shadow-lg">
      <h1 className="text-3xl font-bold text-center mb-4">Privacy Policy</h1>
      <p className="text-center text-gray-400 text-sm">Last Updated: [11-02-2025]</p>

      <section className="mt-8">
        <h2 className="text-2xl font-semibold border-b border-gray-700 pb-2">1. Introduction</h2>
        <p className="mt-2">
          Welcome to <span className="font-bold">ScheduleBuddy</span>, a subsidiary of <span className="font-bold">StudyBuddy</span>. This Privacy Policy explains how we handle user data while providing an automated scheduling experience for teachers and students using Google Calendar.
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-2xl font-semibold border-b border-gray-700 pb-2">2. Data Collection and Usage</h2>
        <p className="mt-2">ScheduleBuddy does not collect, store, or share personal information. The app only accesses the necessary Google Calendar data to facilitate meeting scheduling.</p>
      </section>

      <section className="mt-8">
        <h2 className="text-2xl font-semibold border-b border-gray-700 pb-2">2.1 Google OAuth Permissions</h2>
        <p className="mt-2">When logging in, teachers grant ScheduleBuddy access to:</p>
        <ul className="list-disc pl-6 mt-2 space-y-1">
          <li><span className="font-bold">Google Calendar Scope</span> - Enables the app to create and manage meetings.</li>
          <li><span className="font-bold">Google Auth Scope</span> - Identifies the authenticated teacher to ensure meetings are associated with the correct Google account.</li>
        </ul>
      </section>

      <section className="mt-8">
        <h2 className="text-2xl font-semibold border-b border-gray-700 pb-2">3. How We Use Your Data</h2>
        <p className="mt-2 space-y-2">
          <span className="block"><span className="font-bold">Authentication:</span> Users log in with their Google account and grant necessary permissions.</span>
          <span className="block"><span className="font-bold">Meeting Creation:</span> Teachers can view and schedule meetings for students with pending lessons.</span>
          <span className="block"><span className="font-bold">Automatic Logout:</span> Once meetings are scheduled, the app logs the user out automatically.</span>
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-2xl font-semibold border-b border-gray-700 pb-2">4. Data Storage and Security</h2>
        <p className="mt-2 space-y-2">
          <span className="block"><span className="font-bold">No Data Storage:</span> ScheduleBuddy does not store user credentials, meeting details, or any personal information.</span>
          <span className="block"><span className="font-bold">Access Token Usage:</span> The access token is used temporarily for session-based interactions and is discarded after logout.</span>
          <span className="block"><span className="font-bold">Session Expiry:</span> User sessions end automatically after meetings are scheduled to ensure no persistent data is retained.</span>
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-2xl font-semibold border-b border-gray-700 pb-2">5. Third-Party Services</h2>
        <p className="mt-2">ScheduleBuddy interacts only with Google services and does not share user data with third parties.</p>
      </section>

      <section className="mt-8">
        <h2 className="text-2xl font-semibold border-b border-gray-700 pb-2">6. User Rights and Control</h2>
        <p className="mt-2">
          Teachers can revoke ScheduleBuddy’s access at any time through their Google Account settings: 
          <a href="https://myaccount.google.com/permissions" className="text-teal-400 hover:text-teal-300 ml-2">
            Google Security Settings
          </a>.
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-2xl font-semibold border-b border-gray-700 pb-2">7. Compliance with Google Policies</h2>
        <p className="mt-2">ScheduleBuddy follows Google’s OAuth and API policies, ensuring user data privacy and security. Our app does not use collected data for any purpose other than meeting scheduling.</p>
      </section>

      <section className="mt-8">
        <h2 className="text-2xl font-semibold border-b border-gray-700 pb-2">8. Updates to This Privacy Policy</h2>
        <p className="mt-2">We may update this Privacy Policy to reflect changes in functionality or compliance requirements. Please review this page periodically for any updates.</p>
      </section>

      <section className="mt-8 mb-8">
        <h2 className="text-2xl font-semibold border-b border-gray-700 pb-2">9. Contact Us</h2>
        <p className="mt-2">
          If you have any questions about this Privacy Policy, please contact us at:
        </p>
        <p className="mt-2">
          <span className="font-bold">Horizon Developers</span> <br />
          Email: [legal@studybuddy.ing] <br />
          Address: [Studybud LLC 838 walker road, suit 21-2, DE 19904, United States]
        </p>
      </section>
    </div>
   </div>
  );
};

export default PrivacyPolicy;